import React from 'react';
import { Button, Drawer, DrawerProps, Row, Table } from 'antd';
import { CloseOutlined, SearchOutlined } from '@ant-design/icons';
import moment from 'moment';
import { v4 as uuid } from 'uuid';
import { Label, SecondaryButton, message } from 'components/common';
import { SmartScannerInput, SmartSpace } from 'components/Sales/Smart/SmartComponent';
import { DEFAULT_DATE_FORMAT, HTTP_STATUS_OK } from 'constants/config';
import { fetchProductLotList } from 'services/lot';
import { PoRecvActionType as PRAction } from './context';

type Props = ReduxStateProps & DrawerProps & {
  onSelect?: Function;
  sku: string;
};

const SearchLotDrawer = (props: Props) => {
  const { useState } = React;
  const [lotList, setLotList] = useState<StringKAnyVPair[]>([]);
  const searchLotCode = React.useRef<string>('');

  const columns = [
    /*{
      title: 'SKU',
      dataIndex: 'sku',
    },*/
    {
      title: 'LOT#',
      dataIndex: 'lotNumber',
    },
    {
      title: 'First In Date',
      dataIndex: 'firstInDate',
      render(dt: string) {
        return moment(dt).format(DEFAULT_DATE_FORMAT);
      },
    },
  ];
  

  const drawerFooter = () => {
    return (
      <Row>
        {/*<Col span={12} style={{paddingRight: 5}}>*/}
          <SecondaryButton
            onClick={onClose}
            size="large"
            style={{margin: '0 50px', width: '100%'}}
          >
            <CloseOutlined />
            Cancel
          </SecondaryButton>
        {/*</Col>*/}
        {/*<Col span={12} style={{paddingLeft: 5}}>
          <Button
            onClick={onSelect}
            size="large"
            style={{width: '100%'}}
            type="primary"
          >
            <SelectOutlined />
            Select
          </Button>
        </Col>*/}
      </Row>
    );
  };

  const listRowProps = (row: StringKAnyVPair) => ({
    onClick: () => onRowClick(row),
    /*style: {
      backgroundColor: row.poStatusNum === 2 ? '#FFFBE6' : undefined,
    },*/
  });

  const onClose = (evt: any) => {
    if (props.onClose) props.onClose(evt);
  };

  const onRowClick = (record: StringKAnyVPair) => {
    // console.log('re', record);
    onSelectLot(record);
  };

  const onSelectLot = (lot: StringKAnyVPair) => {
    if (props.onSelect) props.onSelect(lot);
    // @ts-ignore
    onClose();
  };

  const onSearch = async (lotStr?: string) => {
    const { dispatch } = props;
    const lotCode = lotStr === undefined ? searchLotCode.current : lotStr.trim();

    //console.log('s', lotCode);
    dispatch({ type: PRAction.SetLockScreen, params: true });
    try {
      const params = {
        sku: props.sku,
        lot: lotCode,
        status: 1,
        firstInDate: undefined,
        expirationDate: undefined,
        manufactionDate: undefined,
      };
      const {code, isSuccess, data} = await fetchProductLotList(params, {
        pageIndex: 1,
        pageSize: 50,
      });

      if (code === HTTP_STATUS_OK && isSuccess && Array.isArray(data)) {
        console.log('d', data);
        //[...Array(20).keys()].forEach(() => data.push({...data[0]}));
        setLotList(data.map((e: any) => ({...e, uuid: uuid()})));
      }
    } catch(e) {
      message.error({ content: `Fetched lot list error: ${e}` });
    } finally {
      dispatch({ type: PRAction.SetLockScreen, params: false });
    }
  };

  const onSearchLotChange = (evt: any) => {
    const lotCode = evt.target.value.trim();
    //console.log('ch', lotCode);
    searchLotCode.current = lotCode;
  };

  const searchLotButton = () => {
    return (
      <Button
        className="addon-btn-after"
        onClick={() => onSearch()}
        type="primary"
      >
        <SearchOutlined />
      </Button>
    );
  };

  const tableScrollHeight = () => {
    return window.innerHeight - 286;
  };

  return (<>
    <Drawer
      bodyStyle={{ padding: 10 }}
      closable={false}
      footer={drawerFooter()}
      footerStyle={{ padding: 10 }}
      onClose={onClose}
      placement="bottom"
      visible={props.visible}
      width={window.innerWidth}
      height={window.innerHeight - 56}
    >
      <SmartSpace className="mb-0">
        <Row>
          <Label theme={{fontSize: '1.3em'}}>Search LOT</Label>
        </Row>
        <div className="b-b-bordered mb-10 mt-10" />
        <Row align="middle" justify="space-between">
          <Label className="label-bold tail-colon1" theme={{fontSize: '1.3em'}}>LOT#</Label>
          <SmartScannerInput
            addonAfter={searchLotButton()}
            allowClear
            className="fs-24 h-50"
            //defaultValue={currentLotCode}
            onChange={onSearchLotChange}
            onScan={onSearch}
            placeholder="Input LOT# here"
            style={{width: 'calc(100% - 60px)'}}
          />
        </Row>
        {lotList.length > 0 && (
          <Table
            className="mt-10"
            columns={columns}
            dataSource={lotList}
            onRow={listRowProps}
            pagination={false}
            rowKey="uuid"
            scroll={{y: tableScrollHeight()}}
            size="middle"
          />
        )}
      </SmartSpace>
    </Drawer>
  </>);
};

export default SearchLotDrawer;
